// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2TIRf","content":"Consent_content__uSAFn","footer":"Consent_footer__1pXPr"};